import { render, staticRenderFns } from "./ResponsibilitiesPicker.vue?vue&type=template&id=9b7a2582&scoped=true"
import script from "./ResponsibilitiesPicker.vue?vue&type=script&lang=js"
export * from "./ResponsibilitiesPicker.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilitiesPicker.vue?vue&type=style&index=0&id=9b7a2582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7a2582",
  null
  
)

export default component.exports